module.exports = __webpack_public_path__ + "img/keychain.992daee1.png";